<!-- src/views/HomePage.vue -->
<template>
  <div class="home-container">
    <div class="header">
      <h1>Budor之家</h1>
    </div>
    <div class="search">
      <form action="http://www.baidu.com/baidu" target="_blank">

          <input name="tn" type="hidden" value="baidu" />
          <input type="text" class="i" name="word" size="30" />
          <span class="btn_wr">
            <input type="submit" class="btn" value="百度一下" onmousedown="this.className='btn btn_h'" onmouseout="this.className='btn'" />
          </span>

      </form>
    </div>

    <div class="footer">
      &copy;2020 版权所有 <a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备18101794号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
};
</script>

<style scoped>
/* 把原index.html中的样式移到这里（保留完整样式） */
.home-container {
  font:normal 14px Tahoma, Simsun;
  margin:0;
  padding:25px 0 0;
  background:#fff;
}
.header, .links, .footer {
  width:700px;
  margin:15px auto;
  padding:2px;
  text-align:center;
}
.search {
  width:700px;
  margin:15px auto;
  padding:8px 4px;
  text-align:center;
  background:#f8f8f8;
  border:2px solid #f2f2f2;
}
/* 省略其他原样式（确保和之前的静态HTML样式完全一致） */
/* 补充清除浮动（避免导航栏错乱） */
.sites dl:after {
  content:'';
  display:block;
  clear:both;
}
</style>